'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { format } from '@eversports/dates'

import { FILTER_KEY_URL_PARAMS } from '../../Filters.types'
import formatRelativeTodayTomorrowDate from '../../../../../../../../utils/format-relative-today-tomorrow-date'
import type { Locale } from '../../../../../../../../../localization/i18n'

import DateFilterSheet from './DateFilterSheet'
import DateFilterDropdown from './DateFilterDropdown'

interface Props {
  handleRouteChange: (newRoute: string) => void
  locale: Locale
}

export default function DateFilter({ handleRouteChange, locale }: Props) {
  const pathname = usePathname()

  const searchParams = useSearchParams()
  const params = new URLSearchParams(searchParams.toString())

  const activeFilter = params.get(FILTER_KEY_URL_PARAMS.DATE)
  const selectedDate = activeFilter ? new Date(activeFilter) : undefined

  const updateFilter = (dateSelection: Date | undefined) => {
    if (dateSelection) {
      const formattedDate = format(dateSelection, 'yyyy-MM-dd')
      params.set(FILTER_KEY_URL_PARAMS.DATE, formattedDate)
    } else {
      params.delete(FILTER_KEY_URL_PARAMS.DATE)
    }
    handleRouteChange(`${pathname}?${params.toString()}`)
  }

  const resetFilter = () => {
    params.delete(FILTER_KEY_URL_PARAMS.DATE)
    handleRouteChange(`${pathname}?${params.toString()}`)
  }

  const formattedDate = selectedDate && formatRelativeTodayTomorrowDate({ date: selectedDate, locale })

  return (
    <>
      <DateFilterSheet
        selectedDate={selectedDate}
        formattedDate={formattedDate}
        updateFilter={updateFilter}
        resetFilter={resetFilter}
      />
      <DateFilterDropdown selectedDate={selectedDate} formattedDate={formattedDate} updateFilter={updateFilter} />
    </>
  )
}
